<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
      @updateSimplifiedRules="updateSimplifiedRules"
    />
    <OMSRuleHistory ref="ruleHistory" :refresher="updateTableContent" />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import ActionsDialog from "@/own/components/orderManagement/rules/ActionsDialog.vue";
import OMSRuleHistory from "@/own/components/orderManagement/rules/OMSRuleHistory.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  // EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PER_PAGE,
  SET_TABLE_SORT_BY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/omsRules.module";
export default {
  name: "OMSRules",
  components: { DataTable, OMSRuleHistory },
  data: () => ({
    componentForEditing: ActionsDialog,
    componentForAdding: ActionsDialog,
    delete_url: `${process.env.VUE_APP_BASE_URL}/order_management/order_management_rules/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORT_BY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PER_PAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      // EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getOMSRULESTableFilters",
      getTableState: "getOMSRULESTableState",
      getTableData: "getOMSRULESTableData",
      getTableHeaders: "getOMSRULESTableHeaders",
      getTableProperties: "getOMSRULESTableProperties",
      // getTableExportUrl: "getOMSRULESExportUrl",
      getTablePermissions: "getOMSRULESTablePermissions",
    },
    urls: {
      status: `${process.env.VUE_APP_BASE_URL}/order_management/order_management_rules/status`,
      duplicate: `${process.env.VUE_APP_BASE_URL}/order_management/order_management_rules/duplicate_oms_rule`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
    async updateTableContent() {
      this.$store.commit(SET_PAGE_LOADING, true);
      await this.$store
        .dispatch(
          this.table_state.UPDATE_TABLE_DATA,
          this.$store.getters[this.store_names.getTableState]
        )
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    updateSimplifiedRules() {
      this.$refs.ruleHistory.toggleModal();
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
